import React, {RefObject, useCallback, useEffect, useRef, useState} from 'react'

import {EntitySelectorListType} from "../../selector"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import EntitySelectorDocumentsSearch from "./search"
import EntitySelectorDocumentsList from "./list"

type Props = {
    projectId?      : ID

    onEntitySelected: {(entity:MentionOption):void}
    onTab           : {():void}
}

const debug = false
// const debug = "EntitySelectorDocuments"

export default function EntitySelectorDocuments (props:Props) {
    const [search, setSearch]       = useState('')
    const [listType, setListType]   = useState(EntitySelectorListType.RECENT)
    const listRef                   = useRef<any>()

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    const onTypeChanged = useCallback((type:EntitySelectorListType)=>{
        setListType(type)
    }, [])

    const taskFinderRef:RefObject<any> = useRef()

    useEffect(() => {
        const searchString = search?.toLowerCase()
        taskFinderRef.current?.onSearchChange(searchString)
    }, [search])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current.onKeyDown(event)
    }, [listRef.current])

    return (
        <>
            <EntitySelectorDocumentsSearch listType         = {listType}
                                           onKeyDown        = {onKeyDown}
                                           onSearchChanged  = {onSearchChanged}
                                           onTypeChanged    = {onTypeChanged}/>
            <EntitySelectorDocumentsList ref                = {listRef}
                                         search             = {search}
                                         listType           = {listType}
                                         parentProjectId    = {props.projectId}
                                         onEntitySelected   = {props.onEntitySelected}
                                         onTab              = {props.onTab}/>
        </>
    )
}
